import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import "draft-js/dist/Draft.css";
import Swal from "sweetalert2";
import "draft-js-mention-plugin/lib/plugin.css";
import {
  getActiveNurturing,
  stopNurturing,
  sendWhatsapp
} from "../../../services/WhatsappService";
import CopyToClipboard from "../../CopyToClipboard";
import Select from "react-select";
import { useSelector } from "react-redux";
import hasPermission from "../../../utils/hasMultiplePermission";
import axios from "axios";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";
import moment from "moment";
import PermissionsGate from '../../../utils/permissionGate';
import { TABLE_DATE_FORMAT } from '../../../utils/Constants';
const typeOptions = [{ value: "rereg", label: "Re-Registration & Mandatory Articulation Nurturing" }, { value: 'files', label: "File Request Nurturing" }]
const ActiveNurturing = () => {
  const [type, setType] = useState("rereg");
  const history = useHistory();
  const [details, setDetails] = useState([]);
  const [loadingItem, setloadingItem] = useState(false);
  const [loading, setloading] = useState(false)
  const givenPermsisions = useSelector((state) => state.givenPermission);
  const [search, setSearch] = useState("");
  useEffect(() => {
    let response
    response = hasPermission({ scopes: ["wanview"], permissions: givenPermsisions });
    if (!response) {
      history.push("/noaccess")
    }
  }, [])
  useEffect(() => {
    setloading(true);
    const dropdownSource = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        const res = await getActiveNurturing(type, dropdownSource.token);
        if (res.status == 200) {
          setDetails(res?.data?.responseData ?? []);
          setloading(false);
        };
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    };
    fetchData();
    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, [type])

  const renderCourseData = () => {
    let updatedData = []
    let allData = [...details]
    if (search.length) {
      let name = allData.filter(item => {
        let nameIncludes = item.full_name
          ?.toString()
          ?.toLowerCase()
          ?.includes(search.toLowerCase());
        let studentNumberIncludes = item.student_number
          ?.toString()
          ?.toLowerCase()
          ?.includes(search.toLowerCase());
        return nameIncludes || studentNumberIncludes;
      })

      let data = [...name]
      let unique = [...new Set(data)]
      updatedData = unique
    } else {
      updatedData = allData
    }

    const uniqueData = updatedData.filter(
      (value, index, self) =>
        index ==
        self.findIndex(
          t =>
            t.id == value.id
        ),
    )
    return uniqueData
  }

  const exportData = () => {
    let data = renderCourseData()
    let header = [
      'Name',
      'Student Number',
      'Mobile',
      'Re-Reg Intake',
      'Last Whatsapp Sent',
      'Queued To Send',
      'Fail Reason',
      'Last Sent Date',
      'Netsuite Link'
    ]
    Swal.fire({
      title: 'File downloading',
      onOpen: function () {
        Swal.showLoading()
      },
    })
    data = data.map(row => ({
      Name: row.full_name,
      'Student Number': row.student_number,
      'Mobile': row.mobile,
      'Re-Reg Intake': row.reRegIntake,
      'Last Whatsapp Sent': row.last_whatsapp_sent,
      'Queued To Send': row.pending_send,
      'Fail Reason': row?.failedReason,
      'Last Sent Date': moment(row.last_sent).format(TABLE_DATE_FORMAT),
      'Netsuite Link': row.netsuiteLink,
    }))
    const pdfData = data.map(row => {
      return [
        row['Name'],
        row['Student Number'],
        row['Mobile'],
        row['Re-Reg Intake'],
        row['Last Whatsapp Sent'],
        row['Queued To Send'],
        row['Fail Reason'],
        row['Last Sent Date'],
        row['Netsuite Link'],
      ]
    })
    Swal.close()
    return {
      header,
      data,
      pdfData,
      columnStyles: {},
    }
  }
  const handleNurtureDelete = async (id) => {
    try {
      // Confirmation pop-up
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This will stop nurturing for this student!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, stop it!",
      })

      if (!result.isConfirmed) {
        return
      }
      setloadingItem(true);
      const res = await stopNurturing(id);
      setloadingItem(false);
      if (res.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Nurturing has been stopped.",
        })
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }
  const handleSendWhatsapp = async (id) => {
    try {
      // Confirmation pop-up
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This will send the next whatsapp in workflow immidiately!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, send it!",
      })

      if (!result.isConfirmed) {
        return
      }
      setloadingItem(true);
      const student = details.filter((item) => item.id === id)[0];
      const studentFullName = student.full_name;
      const studentCell = student.mobile;
      const res = await sendWhatsapp({ id, type, studentCell, fullName: studentFullName });
      setloadingItem(false);
      if (res.status == 200) {
        // Fire success popup
        Swal.fire({
          icon: "success",
          title: res?.data?.message ?? "Done",
          text: "Whatsapp sent successfully",
          confirmButtonText: "OK",
        })
        window.location.reload();
      } else {
        setloadingItem(false);
        // Fire error popup
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res?.message,
          confirmButtonText: "OK",
        })
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message
        ?? error?.response?.data?.[0]?.message
        ?? error?.response?.data?.error?.message
        ?? error?.message
        ?? "Something went wrong"
      // Fire error popup
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonText: "OK",
      })
      setloadingItem(false);
    }
  }
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "full_name",
      sortField: "full_name",
      sortable: true,
      cell: (row) => (
        <Link to={`/studentAdministration/students/open/${row.student_id}/general`}>
          <span title={row.full_name} className="as-text-blue curser feature-name">
            <span className="textLimit100" data-toggle="modal" data-target="#programmeDateForm" >
              {row.full_name}
            </span>
          </span>
        </Link>
      ),
    },
    {
      name: "Student Number",
      selector: "student_number",
      sortField: "student_number",
      sortable: true,
      cell: (row) => (
        <span title={row.student_number} className="">
          <span className="textLimit100">{row.student_number} <CopyToClipboard data={row.student_number} /></span>
        </span>
      ),
    },
    {
      name: "Mobile",
      selector: "mobile",
      sortField: "mobile",
      sortable: true,
      cell: (row) => (
        <span title={row.mobile} className="">
          <span className="textLimit100">{row.mobile} <CopyToClipboard data={row.mobile} /></span>
        </span>
      ),
    },
    {
      name: "Re-Reg Intake",
      selector: "reRegIntake",
      sortField: "reRegIntake",
      sortable: true,
      cell: (row) => (
        <span title={row.reRegIntake} className="">
          <span className="textLimit100">{row.reRegIntake}</span>
        </span>
      ),
    },
    {
      name: "Last Whatsapp Sent",
      selector: "last_whatsapp_sent",
      sortField: "last_whatsapp_sent",
      sortable: true,
      cell: (row) => (
        <span title={row.last_whatsapp_sent} className="">
          <span className="textLimit100">{row.last_whatsapp_sent}</span>
        </span>
      ),
    },
    {
      name: "Queued To Send",
      selector: "pending_send",
      sortField: "pending_send",
      sortable: true,
      cell: (row) => (
        <span title={"Whatsapp that will send soon"} className="">
          <span className="textLimit100">{row.pending_send} {row?.failedReason && <i className="fa fa-exclamation-circle redText" title={row?.failedReason}></i>}</span>
        </span>
      ),
    },
    {
      name: "Last Sent Date",
      selector: "last_sent",
      sortField: "last_sent",
      sortable: true,
      cell: (row) => (
        <span title={row.last_sent} className="">
          <span className="textLimit100">{row.last_sent ? moment(row.last_sent).format(TABLE_DATE_FORMAT) : "-"}</span>
        </span>
      ),
    },
    {
      name: "Action",
      selector: "Action",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              to={`/studentAdministration/students/open/${row.student_id}/general`}
              className="btn btn-primary rounded-circle">
              <i className="fal fa-folder-open"></i>
            </Link>
            <div className="dropdown btn-dropdown-item">
              <button
                className="btn btn-primary rounded-circle dropdown-toggle"
                type="button"
                disabled={loadingItem}
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="More"
              >
                {loadingItem ? <i className="fal fa-cog fa-spin"></i> : <i className="fal fa-ellipsis-h-alt"></i>}
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <Link
                  className="btn btn-primary rounded-circle"
                  to={{
                    pathname: row.netsuiteLink,
                  }}
                  target="_blank"
                  disabled={loadingItem}
                  title="Open Netsuite Customer"
                >
                  <i className="fal fa-n"></i>
                </Link>
                <PermissionsGate scopes={["wanmodify"]} errorProps={{ disabled: true }}>
                  <button className="btn btn-primary rounded-circle" title="Send next whatsapp in workflow"
                    onClick={() => handleSendWhatsapp(row.id)}
                    disabled={loadingItem
                    }
                  >
                    <i className="fal fa-paper-plane"></i>
                  </button>
                </PermissionsGate>
                <PermissionsGate scopes={["wanmodify"]} errorProps={{ disabled: true }}>
                  <button disabled={loadingItem} className="btn btn-danger rounded-circle" title="Stop nurturing"
                    onClick={() => handleNurtureDelete(row.id)}
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
      ),
    }
  ]);
  return (
    <>
      <div className="card card-body-inr">
        <div className="edit-icon new-card-header">
          <div className="card-header">Active Nurturing</div>{loading && <>{" "}<i className="fas fa-cog fa-spin"></i></>}
        </div>
        <p>The below students have not yet responsed to the requirements to terminate their nurturing</p>
        <Select
          name="type"
          value={typeOptions.find((option) => option.value === type)}
          options={typeOptions}
          onChange={(e) =>
            setType(e.value)
          }
        />
        <br />
      </div >
      <br />
      <DataTableComponentFrontPagination
        columns={columns}
        data={renderCourseData()}
        search={search}
        setSearch={setSearch}
        loading={loading}
        exportData={exportData}
        exportFileName={'NurturingReRegistrations'}
        defaultSort={{
          defaultSortColumn: "last_sent",
          defaultSortAsc: false,
        }}
      />
    </>
  );
};

export default ActiveNurturing;
